(ns ui.components.radio.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/Radio/styles.json
;; Source commit: e7b19185c1c0af99f3d8d3c11f5845edda01a7fe
;; ----------------------------------------------------------------------------

(def radio
  {:_meta
   {:tokens
    ["body-md-font-size"
     "body-md-font-weight"
     "body-md-line-height"
     "helper-font-size"
     "helper-font-weight"
     "helper-line-height"
     "radio-bg-default"
     "radio-bg-disabled"
     "radio-bg-hover"
     "radio-bg-pressed"
     "radio-bg-selected"
     "radio-bg-selected-hover"
     "radio-bg-selected-pressed"
     "radio-border-default"
     "radio-border-disabled"
     "radio-border-hover"
     "radio-border-pressed"
     "radio-border-selected"
     "radio-border-selected-hover"
     "radio-border-selected-pressed"
     "radio-dot-bg"
     "radius-radio"
     "spacing-radio-gap"
     "text-disabled"
     "text-error"
     "text-primary"
     "text-tertiary"],
    :generated-from "src/components/Radio/Radio.styles.ts"},
   :circle
   {:base
    "tw2-relative tw2-inline-flex tw2-items-center tw2-justify-center tw2-w-4 tw2-h-4 tw2-rounded-radio tw2-border tw2-transition-all tw2-duration-150 tw2-ease-in-out hover:tw2-shadow-sm active:tw2-shadow-xs peer-focus-visible:tw2-outline-none peer-focus-visible:tw2-outline-2 peer-focus-visible:tw2-outline-offset-2 peer-focus-visible:tw2-outline-radio-border-selected",
    :state
    {:unchecked
     "tw2-shadow-xs tw2-cursor-pointer tw2-bg-radio-bg-default tw2-border-radio-border-default hover:tw2-bg-radio-bg-hover hover:tw2-border-radio-border-hover active:tw2-bg-radio-bg-pressed active:tw2-border-radio-border-pressed",
     :checked
     "tw2-shadow-xs tw2-cursor-pointer tw2-bg-radio-bg-selected tw2-border-radio-border-selected hover:tw2-bg-radio-bg-selected-hover hover:tw2-border-radio-border-selected-hover active:tw2-bg-radio-bg-selected-pressed active:tw2-border-radio-border-selected-pressed",
     :disabled-unchecked
     "tw2-bg-radio-bg-disabled tw2-border-radio-border-disabled tw2-shadow-none tw2-cursor-not-allowed tw2-opacity-70",
     :disabled-checked
     "tw2-bg-radio-bg-selected tw2-border-radio-border-selected tw2-shadow-none tw2-cursor-not-allowed tw2-opacity-70"},
    :compound-variants [],
    :default-variants {:state "unchecked"}},
   :root
   {:base "tw2-flex tw2-flex-col",
    :compound-variants [],
    :default-variants {}},
   :label
   {:base "tw2-text-body-md",
    :disabled
    {:true "tw2-text-disabled tw2-cursor-not-allowed",
     :false "tw2-text-primary"},
    :compound-variants [],
    :default-variants {:disabled false}},
   :control
   {:base "tw2-flex tw2-items-center tw2-gap-radio-gap",
    :disabled
    {:true "tw2-cursor-not-allowed", :false "tw2-cursor-pointer"},
    :compound-variants [],
    :default-variants {:disabled false}},
   :helper
   {:base "tw2-text-helper tw2-ml-6",
    :disabled {:true "tw2-text-disabled", :false "tw2-text-tertiary"},
    :compound-variants [],
    :default-variants {:disabled false}},
   :input
   {:base "tw2-sr-only tw2-peer",
    :compound-variants [],
    :default-variants {}},
   :dot
   {:base "tw2-block tw2-w-2 tw2-h-2 tw2-rounded-radio",
    :checked
    {:true "tw2-opacity-100 tw2-bg-radio-dot-bg",
     :false "tw2-opacity-0"},
    :compound-variants [],
    :default-variants {:checked false}},
   :required
   {:base "tw2-text-error tw2-ml-1",
    :compound-variants [],
    :default-variants {}}})
